module.exports = __webpack_public_path__ + "img/2_30.d8a26e10.png";